// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3geW4","head":"ProcedureTableInfo_head__29867"};